<script setup>

import axios from "@/request/request";
import {getCurrentInstance} from "vue";
import {getToken} from "@/utils/auth";

let globalProperties = getCurrentInstance().appContext.config.globalProperties;

const openImport = ref(false)
const props = defineProps({
  templateUrl: String,
  templateApi: String,
  fileName: String,
})
const emit = defineEmits(['afterUpload'])

function downLoadMb() {
  if (props.templateApi != null) {
    window.open(props.templateApi);
  } else if (props.templateApi != null) {
    axios({
      url: props.templateApi,
      method: 'get',
      responseType: 'blob'
    }).then(res => {
      console.log(globalProperties)
      globalProperties.$download.excel(res, props.fileName + '.xls')
    })
  }
}

function uploadZsmbBack(e) {
  if (e.code == -1) {
    globalProperties.$modal.msg(e.msg)
  } else {
    globalProperties.$modal.msg(e.data)
  }
  emit('afterUpload')
}

const token = getToken()
</script>

<template>
  <yz-button1 @click="openImport = true">导入</yz-button1>

  <yz-dialog v-model:open="openImport" title="导入" width="20%" destroy-on-close>
    <div class="importDialog">
      <el-button @click="downLoadMb" style="margin-bottom: 20px">下载模板</el-button>
      <el-upload ref="upload"
                 class="upload-demo"
                 action="/api/double-prevention/risk/riskEventAssess/import"
                 limit=1
                 :on-success="uploadZsmbBack" :auto-upload="true" :headers="{token}">
        <template #trigger>
          <yz-button1 type="primary">上传数据</yz-button1>
        </template>
        <el-button style="display: none"></el-button>
        <template #tip></template>
      </el-upload>
    </div>
  </yz-dialog>
</template>


<style scoped lang="less">

</style>
